export default __webpack_public_path__ + "static/media/secure now.52488d58.png";